import $ from 'jquery';

const el = {
    target : '.js_number_of_persons',
    price_per_person : '#price_per_person',
    min_person: '.js_min_person',
    total_price: '.js_total_price',
}

const number_persons = () => {
    if ($(el.price_per_person).length === 0) return;

    $(document).on("change", el.target, function(){
        const number_persons = $(this).val() || 0;
        const price_per_person  = $(el.price_per_person).val()|| 0;
        const total_price   = parseInt(number_persons) * parseInt(price_per_person);

        $(el.min_person).text(number_persons);
        $(el.total_price).text(total_price);


    })
}
const init = () => {
    number_persons();
}

try {
    init();
} catch (error) {
    console.error(error);
}
